import React from "react";
import get from "lodash/get";
import find from "lodash/find";

import AddExerciseModal from "../../../parts/modals/add-exercise";
import EditProgramSettingsModal from "../../../parts/modals/edit-program-settings";
import SingleWorkout from "./SingleWorkout";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const WorkoutController = async ({ req, res, locals, load }) => {
  const { query } = req;
  const {
    activeUser: {
      exerciseLibrary: { assistant },
    },
  } = locals;

  await Promise.all([
    load("editExercises", { cycle: query.cycle, proxyAthlete: query.athlete }),
    load("editCycle", { cycle: query.cycle, proxyAthlete: query.athlete }),
    load("exercisesVolumeForCycle", {
      id: query.cycle,
      program: query.program,
      week: query.week,
      session: query.session,
      proxyAthlete: query.athlete,
    }),
    load("exercisesLiftsForCycle", {
      id: query.cycle,
      program: query.program,
      week: query.week,
      session: query.session,
      proxyAthlete: query.athlete,
    }),
    load("exercisesVolumeGroupZonesForCycle", {
      id: query.cycle,
      program: query.program,
      week: query.week,
      session: query.session,
      proxyAthlete: query.athlete,
    }),
  ]);

  if (!query.session) return res.refreshWith({}, { url: "back" });
  const editExercise = query.editMode
    ? find(locals.editExercises, { _id: query.exercise })
    : {};
  locals.modal = {
    "add-exercise": (
      <AddExerciseModal
        editExercise={editExercise}
        lengthAssistantLibrary={assistant.length}
        secondaryAdded={query.secondaryAdded}
      />
    ),
    "edit-program-settings": <EditProgramSettingsModal />,
    "activity-feed": <ActivityDrawer />,
  }[get(query, "modal.type")];

  res.body = <SingleWorkout />;
};

export default WorkoutController;
